import { useContext, useState } from "react";
import { DataContext } from "../../utils/contexts";
import { exportPdf } from "utils";
import { ExportExcelReceived } from "./ExportExcelReceived";
import { ExportPdfReceived } from "./ExportPdfReceived";
import {  useListExportNew } from "pages/Inventori/Transaction/AddNewItem/utils";
import { ReceivedType } from "../types";
import ModalConfirmExport from "../../components/ModalConfirmExport";

export function ModalExportReceived(props: {
    type: "excel" | "pdf" | string,
    setIsOpen: React.Dispatch<React.SetStateAction<{ isOpen: boolean; type: string, activeTab: string | null }>>
}) {
    const [amount, setAmount] = useState<number>(10)
    const { fill, activeColumn } = useContext(DataContext)

    const { data } = useListExportNew("receive", {
            start_date: fill.dateFrom,
            end_date: fill.dateTo,
            approval_status: fill.approval_status,
            received_status: fill.received_status,
            from_location_id: fill.from_location_id,
            to_location_id: fill.to_location_id,
            jumlah_item: amount
        })

    return (
         <ModalConfirmExport
                    isOpen={true}
                    setIsOpen={props.setIsOpen}
                    amount={amount}
                    setAmount={setAmount}
                    title="Item Received"
                    type={props.type as "excel" | "pdf"}
                    total={data.total_record}
                    onExport={(amount) => {
        
                        if (props.type === "excel") {
                            ExportExcelReceived({
                                data: data.items as ReceivedType[],
                                filter: {
                                    dateFrom: fill.dateFrom,
                                    dateTo: fill.dateTo
                                },
                                module: "INVENTORY",
                                title: "REGISTER RECEIVED",
                                fileName: "register_received",
                                activeColumns: activeColumn!
                            });
                        }
        
                        if (props.type === "pdf") {
                            const documentComponent = (
                                <ExportPdfReceived data={data.items as ReceivedType[]} filter={fill} tableActive={activeColumn!} />
                            )
                            exportPdf({ documentComponent, fileName: "register_received" })
                        }
                    }}
                />
    )
}